/**
 * @generated SignedSource<<81ac7cc6106810cc9afd1c9f4ceaf5c3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NewProfileSidebar_userAccount$data = {
  readonly " $fragmentSpreads": FragmentRefs<"Location_userAccount">;
  readonly " $fragmentType": "NewProfileSidebar_userAccount";
};
export type NewProfileSidebar_userAccount$key = {
  readonly " $data"?: NewProfileSidebar_userAccount$data;
  readonly " $fragmentSpreads": FragmentRefs<"NewProfileSidebar_userAccount">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NewProfileSidebar_userAccount",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Location_userAccount"
    }
  ],
  "type": "UserAccount",
  "abstractKey": null
};

(node as any).hash = "98c5d38d83419d78f30a07ef3492f90f";

export default node;
